/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ILayoutConfig, LAYOUT_TYPE } from "../../../ui/components/Layout/LayoutTypes";

export const DebugResourceViewLayoutConfig: ILayoutConfig = {
	root: {
		type: LAYOUT_TYPE.COLUMN,
		id: "main",
		children: [
			{
				type: LAYOUT_TYPE.PANEL,
				id: "debug",
				isExpandable: false,
				contentComponent: "debugger"
			}
		]
	}
};
